import { Component, ElementRef, AfterViewInit } from '@angular/core';
import { FunctionalLocationHierarchyService } from '../../services/functional-location-hierarchy.service';
import { IndexedDbService } from '../../services/indexed-db.service';
import { TreeNode } from 'primeng/api';
import { FunctionalLocationHierarchyScoresPropagation, FunctionalLocationNode } from '../../utils/functional-location-hierarchy-scores-propagation.utils';
import { FunctionalLocationHierarchyScoresNormalizer } from '../../utils/functional-location-hierarchy-scores-normalizer.utils';
import { FunctionalLocationHierarchyPriorityCounter } from '../../utils/functional-location-hierarchy-priority-counter.utils';
@Component({
    selector: 'app-scheduling',
    templateUrl: './scheduling.component.html',
    styleUrl: './scheduling.component.scss',
    standalone: false
})
export class SchedulingComponent implements AfterViewInit {
  hierarchyNodes: TreeNode[] | undefined = undefined;
  private originalHierarchyNodes: TreeNode[] | undefined = undefined;
  private allMaintPlants: { name: string }[] = [];
  private allPlannerGroups: { name: string }[] = [];
  private allMainWorkCenters: { name: string }[] = [];
  maintPlants: { name: string }[] = [];
  plannerGroups: { name: string }[] = [];
  mainWorkCenters: { name: string }[] = [];
  private _selectedMaintPlants: { name: string }[] = [];
  private _selectedPlannerGroups: { name: string }[] = [];
  private _selectedMainWorkCenters: { name: string }[] = [];
  loading = true;
  private rootNode: FunctionalLocationNode | null = null;

  get selectedMaintPlants(): { name: string }[] {
    return this._selectedMaintPlants;
  }

  set selectedMaintPlants(value: { name: string }[]) {
    this._selectedMaintPlants = value;
    this.updateAvailableOptions();
    this.applyFilters();
  }

  get selectedPlannerGroups(): { name: string }[] {
    return this._selectedPlannerGroups;
  }

  set selectedPlannerGroups(value: { name: string }[]) {
    this._selectedPlannerGroups = value;
    this.updateAvailableOptions();
    this.applyFilters();
  }

  get selectedMainWorkCenters(): { name: string }[] {
    return this._selectedMainWorkCenters;
  }

  set selectedMainWorkCenters(value: { name: string }[]) {
    this._selectedMainWorkCenters = value;
    this.updateAvailableOptions();
    this.applyFilters();
  }
  private _selectedNode: TreeNode | null = null;
  scoresCategoriesChartData: any;
  scoresCategoriesChartOptions: any;
  capacityChartData: any;
  capacityChartOptions: any;
  priorityChartData: any;
  priorityChartOptions: any;
  private _chartsCollapsed = false;

  get chartsCollapsed(): boolean {
    return this._chartsCollapsed;
  }

  set chartsCollapsed(value: boolean) {
    this._chartsCollapsed = value;
    setTimeout(() => this.updateStickyHeaderPosition(), 0);
  }
  private functionalLocationHierarchyKey = 'functionalLocationHierarchy';
  private functionalLocationHierarchyHashKey = 'functionalLocationHierarchyHash';
  isNaN = isNaN;
  Math = Math;

  get selectedNode(): TreeNode | null {
    return this._selectedNode;
  }

  set selectedNode(value: TreeNode | null) {
    this._selectedNode = value;

    console.log('Selected Node:', this._selectedNode);
    this.updateChartData();
    this.updateCapacityChartData();
    this.updatePriorityChartData();
  }

  constructor(
    private functionalLocationHierarchyService: FunctionalLocationHierarchyService,
    private indexedDbService: IndexedDbService,
    private elementRef: ElementRef
  ) {
    this.scoresCategoriesChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
      },
      layout: {
        padding: {
          bottom: 10
        }
      },
      scales: {
        x: {
          ticks: {
            font: {
              size: 9
            }
          }
        },
        y: {
          ticks: {
            font: {
              size: 9
            },
            callback: function(value: any) {
              return Number(value).toFixed(2);
            }
          },
          afterBuildTicks: function(axis: any) {
            const hasZero = axis.ticks.some((t: any) => t.value === 0);
            if (!hasZero) {
              axis.ticks.push({ value: 0 });
            }
            axis.ticks.sort((a: any, b: any) => b.value - a.value);
          },
          grid: {
            drawBorder: true,
            color: (context: any) => context.tick.value === 0 ? '#aaaaaaff' : '#e5e5e5',
            lineWidth: (context: any) => context.tick.value === 0 ? 1 : 1
          }
        }
      }
    };

    this.capacityChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        mode: 'index',
        intersect: false
      },
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            font: { size: 10 },
            boxWidth: 12,
            generateLabels: (chart: any) => {
              const datasets = chart.data.datasets;
              return datasets.map((dataset: any, i: number) => ({
                text: dataset.label,
                fillStyle: i === 0 ? '#22c55e' : '#eab308',
                hidden: !chart.isDatasetVisible(i),
                datasetIndex: i,
                fontColor: '#666',
                lineWidth: 0
              }));
            }
          }
        },
        tooltip: {
          callbacks: {
            title: function(context: any) {
              return 'Semaine ' + context[0].label.substring(1);
            }
          }
        }
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            font: { size: 9 }
          }
        },
        y: {
          stacked: true,
          beginAtZero: true,
          ticks: {
            font: { size: 9 }
          }
        }
      }
    };

    this.priorityChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        }
      },
      scales: {
        x: {
          ticks: {
            font: { size: 9 }
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            font: { size: 9 },
            stepSize: 1
          }
        }
      }
    };
  }

  ngAfterViewInit() {
    this.updateStickyHeaderPosition();
  }

  private updateStickyHeaderPosition() {
    const filterSection = this.elementRef.nativeElement.querySelector('.sticky');
    if (filterSection) {
      const height = filterSection.offsetHeight - 2;
      document.documentElement.style.setProperty('--filters-height', `${height}px`);
    }
  }

  async ngOnInit() {
    this.functionalLocationHierarchyService.getFunctionalLocationHierarchyHash().subscribe({
      next: async (latestHierarchyHash) => { 
        this.hierarchyNodes = await this.getStoredHierarchyNodes();    
        let storedHierarchyHash = await this.getFunctionalLocationHierarchyHash();        
        if (this.hierarchyNodes == null || !storedHierarchyHash || latestHierarchyHash !== storedHierarchyHash) {        
          this.functionalLocationHierarchyService
            .getFunctionalLocationHierarchy()
            .subscribe(async (data) => {
              this.hierarchyNodes = this.transformToTreeNodes(data?.Nodes);                        
              this.originalHierarchyNodes = JSON.parse(JSON.stringify(this.hierarchyNodes));              
              this.PropagateScores();
              this.updateChartData();
              this.updateCapacityChartData();
              this.updatePriorityChartData();
              this.extractFilterOptions();
              this.loading = false;
              await this.setFunctionalLocationHierarchyHash(data.CacheHash);
              await this.storeHierarchyNodes(this.hierarchyNodes);
            });
        } else {
          this.originalHierarchyNodes = JSON.parse(JSON.stringify(this.hierarchyNodes));
          this.PropagateScores();
          this.updateChartData();
          this.updateCapacityChartData();
          this.updatePriorityChartData();
          this.extractFilterOptions();
          this.loading = false;
        }
      },
      error: (error) => {
        console.error('Error getting hierarchy hash:', error);
        this.loading = false;
      },
      complete: () => {
      }
    });
  }

  private PropagateScores() {
    if (!this.hierarchyNodes) return;
    
    const rebuildDataStructure = (treeNode: TreeNode): FunctionalLocationNode => {
      const dataNode = treeNode.data as FunctionalLocationNode;      
      const childTreeNodes = treeNode.children?.filter(child => !child.data?.type) || [];
      dataNode.Children = childTreeNodes.map(child => rebuildDataStructure(child));          
      return dataNode;
    };
    
    const dataNodes = this.hierarchyNodes.map(node => rebuildDataStructure(node));
    
    this.rootNode = {
      Id: 'ROOT',
      ObjectType: 'ROOT',
      Name: 'Root',
      Children: dataNodes,
      ReleasedWorkOrders: [],
      NotReleasedWorkOrders: [],
      Score: 0,
      CategoryScores: {
        LatenessScore: 0,
        PMScore: 0,
        PriorityScore: 0,
        ReadyToExecuteScore: 0,
        WorkTypeScore: 0,
        StatutoryFlagScore: 0
      }
    };
    FunctionalLocationHierarchyScoresPropagation.calculateNodeScores(this.rootNode);
    FunctionalLocationHierarchyScoresNormalizer.normalizeNodeScores(this.rootNode);
    FunctionalLocationHierarchyPriorityCounter.processNode(this.rootNode);
    this.sortNodesByScore(this.hierarchyNodes);
  }

  private async getFunctionalLocationHierarchyHash(): Promise<string | null> {
    const hash = await this.indexedDbService.getItem(this.functionalLocationHierarchyHashKey);
    return hash as string | null;
  }

  private async setFunctionalLocationHierarchyHash(hash: string): Promise<void> {
    await this.indexedDbService.setItem(this.functionalLocationHierarchyHashKey, hash);
  }

  private async getStoredHierarchyNodes(): Promise<TreeNode[] | undefined> {
    try {
      const storedData = await this.indexedDbService.getItem(this.functionalLocationHierarchyKey);
      if (storedData) {
        return storedData as TreeNode[];
      }
      return undefined;
    } catch (error) {
      return undefined;
    }
  }

  private async storeHierarchyNodes(nodes: TreeNode[]): Promise<void> {
    try {
      await this.indexedDbService.setItem(this.functionalLocationHierarchyKey, nodes);
    } catch (error) {
      console.error('Error storing hierarchy nodes to IndexedDB:', error);
    }
  }

  private sortNodesByScore(nodes: any[]): void {
    if (!nodes || nodes.length === 0) return;
   
    const hierarchyNodes = nodes.filter(n => !n.data?.type);
    const workOrders = nodes.filter(n => n.data?.type);
    
    hierarchyNodes.sort((a, b) => b.data.Score - a.data.Score);
    workOrders.sort((a, b) => b.data.Score - a.data.Score);
    
    nodes.length = 0;
    nodes.push(...hierarchyNodes, ...workOrders);

    nodes.forEach(node => {
      if (node.children?.length > 0) {
        this.sortNodesByScore(node.children);
      }
    });
  }

  private transformToTreeNodes(nodes: any[]): TreeNode[] {
    if (!nodes) return [];

    return nodes.map((node) => {
      const children: TreeNode[] = [];

      if (node.Children?.length > 0) {
        children.push(...this.transformToTreeNodes(node.Children));
      }

      if (node.ReleasedWorkOrders?.length > 0) {
        children.push(
          ...node.ReleasedWorkOrders.map((wo: any) => ({
            label: `${wo.WorkOrder?.SAP_WorkOrderId} - ${wo.WorkOrder?.SAP_Description}`,
            data: { ...wo, type: 'ReleasedWorkOrder' },
            children: [],
          }))
        );
      }

      if (node.NotReleasedWorkOrders?.length > 0) {
        children.push(
          ...node.NotReleasedWorkOrders.map((wo: any) => ({
            label: `${wo.WorkOrder?.SAP_WorkOrderId} - ${wo.WorkOrder?.SAP_Description}`,
            data: { ...wo, type: 'NotReleasedWorkOrder' },
            children: [],
          }))
        );
      }

      return {
        label: node.Id == node.Name ? `${node.Id}` : `${node.Id} - ${node.Name}`,
        data: node,
        children,
      };
    });
  }

  getScoreColor(score: number): string {
    if (score >= 0 && score < 20) return 'from-green-500 via-green-500 to-green-600 dark:from-green-600 dark:via-green-500 dark:to-green-600';
    if (score >= 20 && score < 60) return 'from-orange-500 via-orange-500 to-orange-600 dark:from-orange-600 dark:via-orange-500 dark:to-orange-600';
    if (score >= 60 && score < 80) return 'from-orange-600 via-orange-600 to-orange-700 dark:from-orange-700 dark:via-orange-600 dark:to-orange-700';
    return 'from-red-500 via-red-500 to-red-600 dark:from-red-600 dark:via-red-500 dark:to-red-600';
  }

  getUserStatusClass(status: string | undefined): string {
    switch (status) {
      case 'OPEN':
        return 'bg-green-400/80';
      case 'DFSC':
        return 'bg-yellow-400/80';
      case 'RPWO':
        return 'bg-orange-400/80';
      case 'FNSC':
        return 'bg-blue-500/80';
      default:
        return 'bg-gray-400';
    }
  }

  isOverdue(date: string | undefined): boolean {
    if (!date) return false;
    return new Date(date) < new Date();
  }

  getWeeksOverdue(date: string | undefined): string {
    if (!date || !this.isOverdue(date)) return '-';
    const dueDate = new Date(date);
    const today = new Date();
    const diffTime = today.getTime() - dueDate.getTime();
    const diffWeeks = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 7));
    return diffWeeks.toString();
  }

  getPriorityColor(priority: string | undefined): string {
    if (priority === 'A') return 'bg-red-500';
    if (priority === 'B') return 'bg-orange-500';
    if (priority === 'C') return 'bg-yellow-500';
    return 'bg-gray-400';
  }

  updateChartData() {
    const dataSource = this.selectedNode?.data || this.rootNode;
    if (dataSource?.CategoryScores) {
      const scores = dataSource.CategoryScores;
      const hasData =
        scores.LatenessScore !== 0 ||
        scores.PMScore !== 0 ||
        scores.PriorityScore !== 0 ||
        scores.ReadyToExecuteScore !== 0 || 
        scores.WorkTypeScore !== 0 ||
        scores.StatutoryFlagScore !== 0;

      if (hasData) {
        const values = [
          scores.LatenessScore,
          scores.PMScore,
          scores.PriorityScore,
          scores.ReadyToExecuteScore,
          scores.WorkTypeScore,
          scores.StatutoryFlagScore
        ];
        const minValue = Math.min(...values);
        const maxValue = Math.max(...values);
        
        if (minValue >= 0) {
          this.scoresCategoriesChartOptions.scales.y.min = 0;
          this.scoresCategoriesChartOptions.scales.y.max = Math.ceil(maxValue / 5) * 5 + 5;
        } else if (maxValue <= 0) {
          this.scoresCategoriesChartOptions.scales.y.min = Math.floor(minValue / 5) * 5 - 5;
          this.scoresCategoriesChartOptions.scales.y.max = 0;
        } else {
          this.scoresCategoriesChartOptions.scales.y.min = Math.floor(minValue / 5) * 5 - 5;
          this.scoresCategoriesChartOptions.scales.y.max = Math.ceil(maxValue / 5) * 5 + 5;
        }
        
        this.scoresCategoriesChartData = {
          labels: ['Retard', "Type d'ordre", 'Priorité', 'Prêt à planifier', 'Type de travail', 'Témoin statutaire'],
          datasets: [
            {
              data: values,
              backgroundColor: ['#fc4545'],
            },
          ],
        };
      } else {
        this.scoresCategoriesChartData = null;
      }
    } else {
      this.scoresCategoriesChartData = null;
    }
  }

  consolelog(obj : any){
    console.log(obj);
  }

  private extractFilterOptions() {
    const plants = new Set<string>();
    const groups = new Set<string>();
    const workCenters = new Set<string>();
    const traverse = (nodes: TreeNode[]) => {
      nodes.forEach(node => {
        if (node.data?.MaintPlant) plants.add(node.data.MaintPlant);
        if (node.data?.PlannerGroup) groups.add(node.data.PlannerGroup);
        if (node.data?.MainWorkCenter) workCenters.add(node.data.MainWorkCenter);
        if (node.children?.length) traverse(node.children);
      });
    };
    if (this.hierarchyNodes) traverse(this.hierarchyNodes);
    this.allMaintPlants = Array.from(plants).sort().map(name => ({ name }));
    this.allPlannerGroups = Array.from(groups).sort().map(name => ({ name }));
    this.allMainWorkCenters = Array.from(workCenters).sort().map(name => ({ name }));
    this.maintPlants = [...this.allMaintPlants];
    this.plannerGroups = [...this.allPlannerGroups];
    this.mainWorkCenters = [...this.allMainWorkCenters];
  }

  private updateAvailableOptions() {
    if (!this.originalHierarchyNodes) return;

    const plants = new Set<string>();
    const groups = new Set<string>();
    const workCenters = new Set<string>();

    const traverse = (nodes: TreeNode[]) => {
      nodes.forEach(node => {
        const plantMatch = this._selectedMaintPlants.length === 0 || !node.data?.MaintPlant || this._selectedMaintPlants.some(p => p.name === node.data.MaintPlant);
        const groupMatch = this._selectedPlannerGroups.length === 0 || !node.data?.PlannerGroup || this._selectedPlannerGroups.some(g => g.name === node.data.PlannerGroup);
        const workCenterMatch = this._selectedMainWorkCenters.length === 0 || !node.data?.MainWorkCenter || this._selectedMainWorkCenters.some(w => w.name === node.data.MainWorkCenter);

        if (groupMatch && workCenterMatch && node.data?.MaintPlant) plants.add(node.data.MaintPlant);
        if (plantMatch && workCenterMatch && node.data?.PlannerGroup) groups.add(node.data.PlannerGroup);
        if (plantMatch && groupMatch && node.data?.MainWorkCenter) workCenters.add(node.data.MainWorkCenter);

        if (node.children?.length) traverse(node.children);
      });
    };

    traverse(this.originalHierarchyNodes);

    this.maintPlants = Array.from(plants).sort().map(name => ({ name }));
    this.plannerGroups = Array.from(groups).sort().map(name => ({ name }));
    this.mainWorkCenters = Array.from(workCenters).sort().map(name => ({ name }));

    this._selectedMaintPlants = this._selectedMaintPlants.filter(p => plants.has(p.name));
    this._selectedPlannerGroups = this._selectedPlannerGroups.filter(g => groups.has(g.name));
    this._selectedMainWorkCenters = this._selectedMainWorkCenters.filter(w => workCenters.has(w.name));
  }

  private applyFilters() {
    if (!this.originalHierarchyNodes) return;
    
    const expandedKeys = this.getExpandedKeys(this.hierarchyNodes ?? []);
    
    if (this._selectedMaintPlants.length === 0 && this._selectedPlannerGroups.length === 0 && this._selectedMainWorkCenters.length === 0) {
      this.hierarchyNodes = JSON.parse(JSON.stringify(this.originalHierarchyNodes));
      this.PropagateScores();
      this.updateChartData();
      this.updateCapacityChartData();
      this.updatePriorityChartData();
      this.restoreExpandedKeys(this.hierarchyNodes, expandedKeys);
      return;
    }

    const selectedPlantNames = this._selectedMaintPlants.map(p => p.name);
    const selectedGroupNames = this._selectedPlannerGroups.map(g => g.name);
    const selectedWorkCenterNames = this._selectedMainWorkCenters.map(w => w.name);
    
    const matchesFilter = (data: any) => {
      const plantMatch = selectedPlantNames.length === 0 || !data?.MaintPlant || selectedPlantNames.includes(data.MaintPlant);
      const groupMatch = selectedGroupNames.length === 0 || !data?.PlannerGroup || selectedGroupNames.includes(data.PlannerGroup);
      const workCenterMatch = selectedWorkCenterNames.length === 0 || !data?.MainWorkCenter || selectedWorkCenterNames.includes(data.MainWorkCenter);
      return plantMatch && groupMatch && workCenterMatch;
    };
    
    // Recursively filter the FunctionalLocationNode data structure
    const filterDataNode = (dataNode: any): any => {
      if (!dataNode) return dataNode;
      
      const filtered = { ...dataNode };
      
      // Recursively filter Children
      if (filtered.Children) {
        filtered.Children = filtered.Children
          .map((child: any) => filterDataNode(child))
          .filter((child: any) => {
            if (!matchesFilter(child)) return false;
            const hasContent = (child.Children && child.Children.length > 0) ||
                             (child.ReleasedWorkOrders && child.ReleasedWorkOrders.length > 0) ||
                             (child.NotReleasedWorkOrders && child.NotReleasedWorkOrders.length > 0);
            return hasContent;
          });
      }
      
      if (filtered.ReleasedWorkOrders) {
        filtered.ReleasedWorkOrders = filtered.ReleasedWorkOrders.filter((wo: any) => matchesFilter(wo));
      }
      if (filtered.NotReleasedWorkOrders) {
        filtered.NotReleasedWorkOrders = filtered.NotReleasedWorkOrders.filter((wo: any) => matchesFilter(wo));
      }
      
      return filtered;
    };
    
    const filterNodes = (nodes: TreeNode[]): TreeNode[] => {
      return nodes.map(node => {
        const filteredChildren = node.children ? filterNodes(node.children) : [];
        
        // Filter the data property recursively
        const filteredData = node.data?.type ? node.data : filterDataNode(node.data);
        
        return {
          ...node,
          data: filteredData,
          children: filteredChildren
        };
      }).filter(node => {
        if (!matchesFilter(node.data)) return false;
        
        const hasChildren = node.children && node.children.length > 0;
        const isWorkOrder = node.data?.type === 'ReleasedWorkOrder' || node.data?.type === 'NotReleasedWorkOrder';
        
        return hasChildren || isWorkOrder;
      });
    };

    this.hierarchyNodes = filterNodes(JSON.parse(JSON.stringify(this.originalHierarchyNodes)));
    this.PropagateScores();
    this.updateChartData();
    this.updateCapacityChartData();
    this.updatePriorityChartData();
    this.restoreExpandedKeys(this.hierarchyNodes, expandedKeys);
  }

  private getExpandedKeys(nodes: TreeNode[]): Set<string> {
    const keys = new Set<string>();
    const traverse = (nodes: TreeNode[]) => {
      nodes.forEach(node => {
        if (node.expanded && node.label) keys.add(node.label);
        if (node.children) traverse(node.children);
      });
    };
    traverse(nodes);
    return keys;
  }

  private restoreExpandedKeys(nodes: TreeNode[] | undefined, keys: Set<string>) {
    if (!nodes) return;
    const traverse = (nodes: TreeNode[]) => {
      nodes.forEach(node => {
        if (node.label && keys.has(node.label)) node.expanded = true;
        if (node.children) traverse(node.children);
      });
    };
    traverse(nodes);
  }

  updateCapacityChartData() {
    const dataSource = this.selectedNode?.data || this.rootNode;
    if (dataSource?.CapacityDistribution) {
      const capacity = dataSource.CapacityDistribution;
      const weeks = Object.keys(capacity).sort((a, b) => Number(a) - Number(b));
      
      const committedData = weeks.map(week => capacity[week].CommitedHours);
      const uncommittedData = weeks.map(week => capacity[week].UncommitedHours);
      
      const committedColors = weeks.map(w => {
        if (w === '-1') return '#fca5a5'; // light red
        if (w === '0') return 'rgba(34, 197, 94, 0.5)'; // green 50% opacity
        return '#22c55e'; // green
      });

      const uncommittedColors = weeks.map(w => {
        if (w === '-1') return '#b91c1c'; // dark red
        if (w === '0') return 'rgba(234, 179, 8, 0.5)'; // yellow 50% opacity
        return '#eab308'; // yellow
      });
      
      this.capacityChartData = {
        labels: weeks.map(w => {
          if (w === '-1') return 'Passé';
          else if (w === '17') return '...';
          else if (w === '0') return '0';
          return `+${w}`;
        }),
        datasets: [
          {
            label: 'Heures engagées',
            data: committedData,
            backgroundColor: committedColors
          },
          {
            label: 'Heures non engagées',
            data: uncommittedData,
            backgroundColor: uncommittedColors
          }
        ]
      };
    } else {
      this.capacityChartData = null;
    }
  }

  isLastChild(rowNode: any): boolean {
    if (!rowNode.parent) return true;
    const siblings = rowNode.parent.children;
    return siblings && rowNode === siblings[siblings.length - 1];
  }

  updatePriorityChartData() {
    const dataSource = this.selectedNode?.data || this.rootNode;
    if (dataSource?.PriorityCounts) {
      const counts = dataSource.PriorityCounts;
      const priorities = Object.keys(counts).sort();
      
      const colors = priorities.map(p => {
        if (p === 'A') return '#ef4444';
        if (p === 'B') return '#f97316';
        if (p === 'C') return '#eab308';
        if (p === 'D') return '#3b82f6';
        return '#6b7280';
      });
      
      this.priorityChartData = {
        labels: priorities,
        datasets: [
          {
            data: priorities.map(p => counts[p]),
            backgroundColor: colors
          }
        ]
      };
    } else if (this.selectedNode?.data?.WorkOrder?.SAP_Priority) {
      const priority = this.selectedNode.data.WorkOrder.SAP_Priority;
      let color = '#6b7280';
      if (priority === 'A') color = '#ef4444';
      else if (priority === 'B') color = '#f97316';
      else if (priority === 'C') color = '#eab308';
      else if (priority === 'D') color = '#3b82f6';
      
      this.priorityChartData = {
        labels: [priority],
        datasets: [
          {
            data: [1],
            backgroundColor: [color]
          }
        ]
      };
    } else {
      this.priorityChartData = null;
    }
  }
}
